import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { DeleteCustomerModalComponent } from "./delete-customer-modal.component";

@NgModule({
    imports: [
        CommonModule,
        TranslateModule
    ],
    declarations: [
        DeleteCustomerModalComponent
    ],
    exports: [
        DeleteCustomerModalComponent
    ]
})
export class DeleteCustomerModalModule { }
